import scada from './scada'
const STRUCT_MODE = {
  BY_CLUSTER: 1,
  BY_FACILITY: 2,
  BY_ABC: 3,
};
export default {
  state: {
    facility: [],
    dept: [],
    struct: [],
    monitoring: null,
    monitoringStruct: [],
    hideRepeatWell: true,
    structMode: STRUCT_MODE.BY_CLUSTER,
    enableEventSound: false,
    enableEventFacilitySound: false,
    speechRate: 1.2,
    speechPitch: 1.6,
    propertySource: null,
    monitoringUpdate: null,
    propertyUpdate: null,
    eventUpdate: null,
    propertyColor: {}
  },
  actions: {
    setStruct: ({ commit }, val) => {
      commit('SET_STRUCT', val)
    },
    setMonitoring: ({ commit }, val) => {
      commit('SET_MONITORING', val)
    },
    setMonitoringStruct: ({ commit }, val) => {
      commit('SET_MONITORING_STRUCT', val)
    },
    setMonitoringUpdate: ({ commit }, val) => {
      commit('SET_MONITORING_UPDATE', val)
    },
    setHideRepeatWell: ({ commit }, val) => {
      commit('SET_HIDE_REPEAT_WELL', val)
    },
    setStructMode: ({ commit }, val) => {
      commit('SET_STRUCT_MODE', val)
    },
    setEnableEventSound: ({ commit }, val) => {
      commit('SET_ENABLE_EVENT_SOUND', val)
    },
    setEnableEventFacilitySound: ({ commit }, val) => {
      commit('SET_ENABLE_EVENT_FACILITY_SOUND', val)
    },
    setPropertyUpdate: ({ commit }, val) => {
      commit('SET_PROPERTY_UPDATE', val)
    },
    setEventUpdate: ({ commit }, val) => {
      commit('SET_EVENT_UPDATE', val)
    },
    setDept: ({ commit }, val) => {
      commit('SET_DEPT', val)
    },
    setPropertySource: ({ commit }, val) => {
      const prerpare = function (values) {
        values = `{${values.replaceAll('=', ':')}}`;
        if (values.indexOf(';') > -1) {
          let result = [];
          let text = values;
          for (let index = 0; index < values.match(/[;]/g).length; index++) {
            result.push(text.substring(0, text.indexOf(';')));
            text = text.substring(text.indexOf(';'));
            text = text.substring(text.indexOf('"'));
          }
          values = result.join(',') + '}';
        }
        return JSON.parse(values);
      }
      let date = new Date();
      date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 1)
      const propertySource = val.map(item => ({
        ...item,
        property_data_values: item.property_data_values ? prerpare(item.property_data_values) : {},
        first_value_data: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 1)
      }));
      commit('SET_PROPERTY_SOURCE', propertySource)
    },
    setFacility: ({ commit }, val) => {
      commit('SET_FACILITY', val)
    },
    setPropertyColor: ({ commit }, { facilityTypeId, systemName, flangeNo, value }) => {
      const key = `${String(facilityTypeId)}_${String(systemName)}_${String(flangeNo)}`;
      commit('SET_PROPERTY_COLOR', { key: key, value: value })
    },
    setSpeechRate: ({ commit }, val) => {
      commit('SET_SPEECH_RATE', val);
    },
    setSpeechPitch: ({ commit }, val) => {
      commit('SET_SPEECH_PITCH', val);
    },
  },
  mutations: {
    SET_DEPT(state, dept) {
      state.dept = dept;
    },
    SET_FACILITY(state, facility) {
      state.facility = facility;
    },
    SET_STRUCT(state, struct) {
      state.struct = struct;
    },
    SET_MONITORING_UPDATE(state, monitoringUpdate) {
      state.monitoringUpdate = monitoringUpdate;
    },
    SET_PROPERTY_UPDATE(state, propertyUpdate) {
      state.propertyUpdate = propertyUpdate;
    },
    SET_EVENT_UPDATE(state, eventUpdate) {
      state.eventUpdate = eventUpdate;
    },
    SET_MONITORING(state, monitoring) {
      state.monitoring = monitoring || [];
    },
    SET_MONITORING_STRUCT(state, monitoringStruct) {
      state.monitoringStruct = monitoringStruct || [];
    },
    SET_HIDE_REPEAT_WELL(state, hideRepeatWell) {
      state.hideRepeatWell = hideRepeatWell;
    },
    SET_PROPERTY_SOURCE(state, propertySource) {
      state.propertySource = propertySource;
    },
    SET_ENABLE_EVENT_SOUND(state, enableEventSound) {
      state.enableEventSound = enableEventSound;
    },
    SET_STRUCT_MODE(state, structMode) {
      state.structMode = structMode;
    },
    SET_ENABLE_EVENT_FACILITY_SOUND(state, enableEventFacilitySound) {
      state.enableEventFacilitySound = enableEventFacilitySound;
    },
    SET_PROPERTY_COLOR(state, { key, value }) {
      if (!state.propertyColor) state.propertyColor = {};
      state.propertyColor[key] = value;
    },
    SET_SPEECH_RATE(state, value) {
      state.speechRate = value;
    },
    SET_SPEECH_PITCH(state, value) {
      state.speechPitch = value;
    },
  },
  getters: {
    facility: s => s.facility,
    dept: s => s.dept,
    struct: s => s.struct,
    monitoring: s => s.monitoring,
    monitoringStruct: s => s.monitoringStruct,
    propertySource: s => s.propertySource,
    structMode: s => s.structMode ?? 1,
    monitoringUpdate: s => s.monitoringUpdate ?? 20,
    propertyUpdate: s => s.propertyUpdate ?? 12,
    eventUpdate: s => s.eventUpdate ?? 800,
    hideRepeatWell: s => s.hideRepeatWell ?? true,
    enableEventSound: s => s.enableEventSound ?? false,
    enableEventFacilitySound: s => s.enableEventFacilitySound ?? false,
    speechRate: s => s.speechRate ?? 1.2,
    speechPitch: s => s.speechPitch ?? 1.6,
    propertyColor: (s) => (facilityTypeId, systemName, flangeNo) => {
      const key = `${String(facilityTypeId)}_${String(systemName)}_${String(flangeNo)}`;
      return s.propertyColor && s.propertyColor[key] ? s.propertyColor[key] : null;
    },
  },
  modules: {
    scada
  }

}
